<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<el-button type="danger" @click="deleteChange" :disabled="this.checkUids.length === 0"> 批量删除
				</el-button>
				<el-button @click="dialogFormVisible = true" type="primary">添加马甲</el-button>
			</div>
			<el-table ref="multipleTable" :data="userList" tooltip-effect="dark" style="width: 100%"
				@selection-change="selsChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="sex" label="性别"> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column width="200px;">
					<template slot-scope="scope">
						<el-button type="danger" @click="deleteUser(scope.row.uid,scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
				layout="total,prev,pager,next,jumper" :total="userLength">
			</el-pagination>
		</el-card>
		<!-- 添加马甲弹窗 -->
		<el-dialog title="创建马甲" :visible.sync="dialogFormVisible">
			<el-form :model="form" ref="form">
				<el-form-item label="昵称">
					<el-input v-model="form.username" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="头像">
					<el-upload ref="uUpload" class="avatar-uploader" name="file" :headers="headers" :action="action"
						:on-success="uploadSuccess1" :show-file-list="false">
						<img v-if="form.avatar" :src="form.avatar" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="性别">
					<el-radio v-model="form.gender" :label="1">男</el-radio>
					<el-radio v-model="form.gender" :label="2">女</el-radio>
					<el-radio v-model="form.gender" :label="3">保密</el-radio>
				</el-form-item>
<!--				<el-form-item label="地区">-->
<!--					<el-cascader :props="regionProps" :options="region" @change="regionChange"></el-cascader>-->
<!--				</el-form-item>-->
				<el-form-item label="个人说明">
					<el-input type="textarea" placeholder="(选填)请填写个人说明" v-model="form.intro" autocomplete="off">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="userAdd">确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import region from "./region.js";
	export default {
		data() {
			return {
				btnLoading: false,
				btnDisabled: false,
				action: this.$c.domain + "common/uploadFile",
				headers: {
					token: this.$store.state.userInfo.token
				},
				checkUids: [], //选中的用户ids
				currentPage: 1, //初始页
				pagesize: 10,
				userList: [],
				userLength: 0,
				dialogVisible: false,
				editUid: null,
				dialogFormVisible: false,
				form: {
					username: "",
					avatar: "",
					gender: 0,
					province: "",
					city: "",
					intro: ""
				},
				region: region,
				regionProps: {
					value: "label"
				}
			};
		},
		created() {
			this.handleUserList();
		},
		methods: {
			regionChange(e) {
				this.form.province = e[0];
				this.form.city = e[1];
			},
			uploadSuccess1(e) {
				if (e.code == 200) {
					this.form.avatar = e.result.url;
				}
			},
			userAdd() {
				this.btnLoading = true;
				this.btnDisabled = true;

				if (!this.form.username) {
					this.$message.error("昵称不能为空");
					return;
				}
				this.$H.post("user/vestAdd", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.$refs.uUpload.clearFiles();
						
						this.form = {
							username: "",
							avatar: "",
							gender: 0,
							province: "",
							city: "",
							intro: ""
						},
						
						this.$message.success(res.msg)
						this.dialogFormVisible = false;
						this.handleUserList();
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				console.log(this.currentPage);
				this.handleUserList();
			},
			handleUserList() {
				this.$H
					.get("user/list", {
						page: this.currentPage,
						type: 2
					})
					.then((res) => {
						console.log(res);
						this.userList = res.result.data;
						this.userLength = res.result.total;
						this.pagesize = res.result.per_page;
					});
			},
			deleteUser(uid, index) {
				this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//删除用户的接口
					this.$H.post("user/delUser", {
						uid: uid
					}).then(res => {
						if (res.code == 200) {
							this.userList.splice(index, 1)
							this.$message.success("删除成功");
						}
					})
				})
			},
			selsChange(e) {
				let uids = [];
				e.forEach(item => {
					uids.push(item.uid)
				})
				this.checkUids = uids
			},
			deleteChange() {
				this.$confirm('确定删除选中马甲用户?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post("user/delUser", {
						uid: this.checkUids
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.handleUserList();
						}
					})
				})
			},
			changeStatus(uid, status) {
				console.log("uid:" + uid + ",status:" + status)
				//改变用户状态的接口
			}
		},
	};
</script>

<style>
	.avatar {
		width: 100px;
		height: 100px;
	}
</style>
